import React from "react";

import { Header, Input, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import Pagination from "../../../components/Pagination/Pagination.js";
import { TableComponent } from "../../../components/Table/table.js";
import BackButton from "../../../components/BackButton/BackButton.js";
import ActionDropdown from "../../../components/ActionDropdown/ActionDropdown.js";
import Loading from "../../../components/Loading/Loading.js";
import { api } from "../../../api/api.js";
import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
import { reconciliation_url } from "../../../api/urls.js";
import axios from "axios";
import unknownError from "../../../utils/unknownError.js";
import { modules, perms } from "../../../api/codes.js";
import { ProtectedElement } from "../../../components/ProtectedElement/ProtectedElement.js";
import { DashboardImage } from "../../../components/DashboardImage/DashboardImage.js";
import { TextChip } from "../../../components/TextChip/TextChip.js";

const title = "Reconciliation";
const apiUrl = reconciliation_url;
const currentRoute = "reconciliation";
const module = modules.Reconciliation;
const searchFeild = "order_id";
const headers = [
  "Seller Image",
  "Seller Name",
  "Order ID",
  "Gross Sales",
  "Charges",
  "Net Payable",
  //   "Reserve",
  //   "Settlement Date",
  "Status",
  "Action",
];

const Reconciliation = () => {
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [refetcher, setRefetcher] = useState(false);

  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState();

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getData = async () => {
      setData();
      try {
        const res = await api.get(
          apiUrl + "?limit=" + limit + "&offset=" + offset,
          {
            cancelToken: source.token,
            headers: {
              module: module,
            },
          }
        );
        setData(res.data);
        setCount(res.data.count);
      } catch (err) {
        unknownError(err);
      }
    };
    getData();
    return () => {
      source.cancel();
    };
  }, [refetcher, limit, offset]);

  const refetch = () => {
    setRefetcher((v) => !v);
  };
  const bodyMap = (d, refetch) => {
    return [
      <div style={{ display: "flex", gap: "10px" }}>
        <DashboardImage
          // src={d?.product_inventory?.[0]?.image01}
          src={d?.seller_image_url}
          height="75px"
          width="75px"
        />
      </div>,
      d.company_name,
      d.order_id,
      //   moment(d.updated_at).format("DD-MM-YYYY"),
      //   "Admin",
      //   "Admin",
      d?.currency_symbol + d?.total_amount_paid_amt,
      d?.currency_symbol + d?.seller_charges_total,
      d?.currency_symbol + d?.net_payable_amount,
      <TextChip
        text={d?.is_reconciled ? "Reconciled" : "Pending"}
        color={d?.is_reconciled ? "#10692C" : "#E77A26"}
      />,
      <ActionDropdown
        ViewButton={({ setOpen }) => (
          <ProtectedElement module={module} perm={perms.view}>
            <Link to={currentRoute + "/" + d.id}>
              <div
                className="option"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <div className="icon-btn yellow-icon">
                  <EyeIcon />
                </div>
                <div className="yellow-title">View</div>
              </div>
            </Link>
          </ProtectedElement>
        )}
      />,
    ];
  };
  return (
    <>
      <BackButton />
      <div id="heading">
        <Header>{title}</Header>
        <div className="right">
          <Input
            type="text"
            placeholder="Search by order ID"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            icon={<Icon name="search" link id="search-icon" />}
          />
        </div>
      </div>
      {data ? (
        <>
          <TableComponent
            headers={headers}
            body={
              data.results
                ? data.results
                    .filter((d) =>
                      d[searchFeild]
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    )
                    .map((d) => {
                      return bodyMap(d, refetch);
                    })
                : []
            }
            showbottom={false}
            disableHeaderPopup
          />
        </>
      ) : (
        <Loading />
      )}
      {count ? (
        <Pagination count={count} setLimit={setLimit} setOffset={setOffset} />
      ) : null}
    </>
  );
};

export default Reconciliation;
